import { type AttributeValue } from "../../attribute/AttributeSet";
import { type UserAttributeSet, UserAttributeType } from "../UserAttributeSet";

import { attributeListToMap } from "@/utils/attributes";

export enum Language {
  ARABIC = "ar",
  BENGALI = "bn",
  CHINESE = "zh",
  GERMAN = "de",
  ENGLISH = "en",
  SPANISH = "es",
  FRENCH = "fr",
  GUJARATI = "gu",
  HINDI = "hi",
  INDONESIAN = "id",
  ITALIAN = "it",
  JAPANESE = "ja",
  JAVANESE = "jv",
  KOREAN = "ko",
  MARATHI = "mr",
  PUNJABI = "pa",
  PORTUGUESE = "pt",
  RUSSIAN = "ru",
  TAMIL = "ta",
  TELUGU = "te",
  THAI = "th",
  TURKISH = "tr",
  URDU = "ur",
  VIETNAMESE = "vi",
  WU_CHINESE = "zh-wuu",
  OTHER = "other",
  ASK_ME = "ask_me",
}

const LANGUAGE_ATTRIBUTE_VALUES: ReadonlyArray<AttributeValue> = [
  { id: Language.ARABIC, label: "Arabic", iconLabel: "🇸🇦" },
  { id: Language.BENGALI, label: "Bengali", iconLabel: "🇧🇩" },
  { id: Language.CHINESE, label: "Chinese", iconLabel: "🇨🇳" },
  { id: Language.GERMAN, label: "German", iconLabel: "🇩🇪" },
  { id: Language.ENGLISH, label: "English", iconLabel: "🇬🇧" },
  { id: Language.SPANISH, label: "Spanish", iconLabel: "🇪🇸" },
  { id: Language.FRENCH, label: "French", iconLabel: "🇫🇷" },
  { id: Language.GUJARATI, label: "Gujarati", iconLabel: "🇮🇳" },
  { id: Language.HINDI, label: "Hindi", iconLabel: "🇮🇳" },
  { id: Language.INDONESIAN, label: "Indonesian", iconLabel: "🇮🇩" },
  { id: Language.ITALIAN, label: "Italian", iconLabel: "🇮🇹" },
  { id: Language.JAPANESE, label: "Japanese", iconLabel: "🇯🇵" },
  { id: Language.JAVANESE, label: "Javanese", iconLabel: "🇮🇩" },
  { id: Language.KOREAN, label: "Korean", iconLabel: "🇰🇷" },
  { id: Language.MARATHI, label: "Marathi", iconLabel: "🇮🇳" },
  { id: Language.PUNJABI, label: "Punjabi", iconLabel: "🇮🇳" },
  { id: Language.PORTUGUESE, label: "Portuguese", iconLabel: "🇵🇹" },
  { id: Language.RUSSIAN, label: "Russian", iconLabel: "🇷🇺" },
  { id: Language.TAMIL, label: "Tamil", iconLabel: "🇱🇰" },
  { id: Language.TELUGU, label: "Telugu", iconLabel: "🇮🇳" },
  { id: Language.THAI, label: "Thai", iconLabel: "🇹🇭" },
  { id: Language.TURKISH, label: "Turkish", iconLabel: "🇹🇷" },
  { id: Language.URDU, label: "Urdu", iconLabel: "🇵🇰" },
  { id: Language.VIETNAMESE, label: "Vietnamese", iconLabel: "🇻🇳" },
  { id: Language.WU_CHINESE, label: "Wu Chinese", iconLabel: "🇨🇳" },
  { id: Language.OTHER, label: "Other", iconLabel: "🌐" },
  { id: Language.ASK_ME, label: "Ask Me", iconLabel: "❓" },
];

export const UserLanguageAttributeSet: UserAttributeSet = {
  id: UserAttributeType.LANGUAGES,
  isMultiSelect: true,
  map: attributeListToMap(LANGUAGE_ATTRIBUTE_VALUES),
} as const;
